import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function GetAllSuperadminsService(token, page, query, pagination) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log("Query from datagrid", query);
      let url;
      if (query === "") {
        console.log("URL without params inside");
        url = `${URL_AUTH}/api/admin/v1/admins?page=${page}&pagination=${pagination}`;
      } else {
        console.log("URL with params inside", query);
        url = `${URL_AUTH}/api/admin/v1/admins?${query}&page=${page}&pagination=${pagination}`;
      }
      const response = await axios.get(url, {
        headers: {
          "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
          Authorization: `Bearer ${token}`,
        }
      });
      // console.log("request from service getSuperadmins:", response.data);
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}
